import React, { Component } from 'react'
import Link from 'gatsby-link'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {Background} from '../Background/background';
import {Slide} from '../Slide/slide'

import './background-reel.css'

class BackgroundReel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
    };

    this.incrementIndex = this.incrementIndex.bind(this);
    this.decrementIndex = this.decrementIndex.bind(this);
    this.renderBackgrounds = this.renderBackgrounds.bind(this);
    this.renderSlide = this.renderSlide.bind(this);
  }

  startReel() {
    this.updateClock = setInterval(
      () => this.incrementIndex(),
      7000
    );
  }

  stopReel() {
    clearInterval(this.updateClock);
  }

  resetReel() {
    this.stopReel();
    this.startReel();
  }

  componentDidMount() {
    this.startReel();
  }

  componentWillUnmount() {
    this.stopReel();
  }

  incrementIndex() {
    this.setState({
      index : (this.state.index + 1) % this.props.backgrounds.length,
    });

    this.resetReel();
  }

  decrementIndex() {
    let decrementedIndex = this.state.index == 0 ? this.props.backgrounds.length - 1 : this.state.index - 1;
    this.setState({
      index : decrementedIndex,
    });

    this.resetReel();
  }

  renderBackgrounds(backgroundsData, indexOfVisibleBackground) {
    let isBackgroundDarkened = this.props.isBackgroundDarkened;
    let sizes = this.props.sizes;

    return backgroundsData.map(
      function(data, index) {
        return (
          <div key={index}>
            <Background
              sizes = {sizes[index]}
              href = {data.href}
              name = {data.name}
              isDarkened = {isBackgroundDarkened}
              shouldDisplayName = {true}
              isVisible = {index === indexOfVisibleBackground}>
            </Background>
          </div>
        );
      }
    );
  }

  renderSlide(href) {
    return (
      <Slide
        canAdvanceRight = {true}
        canAdvanceLeft = {true}
        onAdvanceRight = {this.incrementIndex}
        onAdvanceLeft = {this.decrementIndex}
        isLink = {this.props.areSlidesClickable}
        href = {href}
        >
      </Slide>
    );
  }

  render () {
    let sizes = this.props.sizes[this.state.index];
    let backgroundsData = this.props.backgrounds;
    let href = backgroundsData[this.state.index].href;
    let backgrounds = this.renderBackgrounds(backgroundsData, this.state.index);
    let slide = this.renderSlide(href);

    return (
      <div className="stack-bottom span-viewport">

        {slide}
        {backgrounds}

      </div>
    );
  }
}


export default {BackgroundReel}



// WEBPACK FOOTER //
// ./src/components/BackgroundReel/background-reel.js